import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { MyAxios } from "../../data/api.axios";
import { apiURL } from "../../data/api.url";
import MainButton from "../../components/Button";
import { LogoIcon } from "../../assets/svgs";
import { useNavigate } from "react-router-dom";
import { getAppTheme } from "../../utils/theme";
import { storageConst } from "../../utils/constants";
import SpinnerIcon from "../../assets/svgs/spinner";
import Notification from "../../components/notification";

const OtpPage = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string[]>(Array(4).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [isLoader, setIsLoader] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [show, setShow] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value.length === 1 && index < inputRefs.current.length - 1) {
      // Move to the next input if a digit is entered
      inputRefs.current[index + 1]?.focus();
    } else if (value.length === 0 && index > 0) {
      // Move to the previous input if input is cleared
      inputRefs.current[index - 1]?.focus();
    }
  };
  useEffect(() => {
    let timer: any;
    // if (isLoader) {
    setCountdown(60); // Start at 60 seconds
    timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer); // Stop the timer at 0
          setIsLoader(false); // Reset isLoader
          return 0;
        }
        return prev - 1; // Decrement countdown
      });
    }, 1000); // Update every 1 second
    // }
    return () => clearInterval(timer); // Cleanup timer
  }, []);

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && index > 0) {
      // Move to the previous input on backspace
      inputRefs.current[index - 1]?.focus(); // Use optional chaining to avoid null issues
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const onSubmit = async () => {
    try {
      setIsLoader(true);
      const payload = { otp: otp.join("") };
      const accessToken = localStorage.getItem(storageConst.APPTOKEN);

      if (!accessToken) {
        alert("Access token not found. Please log in again.");
        return;
      }

      console.log({ otp });

      const response = await MyAxios.post(apiURL.verifyOtp, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log("Otp verify Successfully:", response.data);
      localStorage.setItem(storageConst.ISLOGGIN, storageConst.ISLOGGIN);
      setNotification({ type: "Success", message: "Otp Verified, Login Successful!" });
      setIsLoader(false);

      // Handle successful login, e.g., save token, redirect user

      navigate("/");
    } catch (error) {
      console.error("Error during login:", error);
      // alert("Failed to login. Please check your credentials.");
      setNotification({ type: "Error", message: "Invalid Otp. Please enter right Otp ." });
      setIsLoader(false);
    }
  };
  const handleNavigation = () => {
    // navigate("/register-site");
    // navigate("/");
  };
  useEffect(() => {
    if (notification.message) {
      const timer = setTimeout(() => {
        setShow(false);
        setNotification({ type: "", message: "" });
      }, 123000);
      return () => clearTimeout(timer);
    }
  }, [notification]); 
  return (
    <div
      className=" bg-bg bg-center min-h-screen w-full py-4 flex items-center justify-center"
      style={{
        backgroundImage: `${
          getAppTheme() === "dark"
            ? "url('/assets/images/darkmode.png')"
            : "url('/assets/images/bgLight.png')"
        }`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {" "}
      <div className="bg-bgCard px-8 pt-4 pb-8 rounded-lg flex flex-col gap-y-5 shadow-md w-full max-w-md">
        <div className="flex justify-center">
          <LogoIcon />
        </div>
        <div>
          <p className=" font-semibold mb-1 text-center text-3xl">
            Verify Your OTP
          </p>
          <p className="text-center font-normal text-base text-textPrimary">
            We have sent a verification code on your email address
            a******@gmail.com
          </p>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-10">
            <div className=" mt-4 justify-center items-center gap-1.5 flex">
              <div className="mt-4 flex justify-center gap-x-4">
                {Array(4)
                  .fill("")
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      className="w-[59px] h-[67px] focus:outline-none bg-bg border border-bg hover:border-orange focus:border-orange rounded-lg text-center text-2xl font-medium leading-[44.25px]"
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
              </div>
            </div>
            <div className="">
              <div className=" text-center mt-2">
                <span className=" text-xs font-normal font-[Poppins] leading-snug">
                  Didn’t receive code? {"  "}
                </span>
                <span className="text-gradientThree text-xs font-medium font-['Poppins'] leading-snug">
                  {countdown == 0 ? "ReSend Otp " : countdown + " " + "s"}
                </span>
              </div>

              <MainButton
                type="submit"
                label={isLoader ? <SpinnerIcon /> : "Continue"}
                onClick={handleNavigation}
                className=" mt-5 focus:ring-none! focus:border-none! h-[55px] bg-gradient-to-br from-gradientOne to-gradientTwo focus:outline-none rounded-lg justify-center items-center gap-2.5 inline-flex w-full text-white text-base font-medium "
              ></MainButton>
            </div>
          </form>
          {notification.message && <Notification type={notification.type} label={notification.message} onClick={()=>setShow(true)} />}
        </div>
      </div>
    </div>
  );
};

export default OtpPage;
